export default __webpack_public_path__ + "static/media/sent.acddcabb.svg";